import {
    getPrimarySubjectOptionsForClass,
    PRIMARY_SCHOOL_SUBJECT_OPTIONS_UPPER,
} from "./primarySubjectCatalog";

/**
 * Secondary / general subject titles for the add-subject dropdown.
 * `subCode` is derived internally for the API — admins do not enter codes.
 */
export const SECONDARY_SCHOOL_SUBJECT_OPTIONS = [
    "English",
    "Chichewa",
    "Mathematics",
    "Biology",
    "Chemistry",
    "Physics",
    "Agriculture",
    "Geography",
    "History",
    "Bible Knowledge",
    "Bible Knowledge / Religious Studies",
    "Life Skills",
    "Social Studies",
    "Social and Life Skills",
    "Computer Studies / ICT",
    "Computer Studies",
    "Business Studies",
    "Technical Drawing",
    "Home Economics",
    "Primary Science",
    "Expressive Arts",
];

/** @deprecated Use getSubjectOptionsForClass instead */
export const SCHOOL_SUBJECT_OPTIONS = SECONDARY_SCHOOL_SUBJECT_OPTIONS;

export function getSubjectOptionsForClass({ isPrimaryClass, classRow }) {
    if (isPrimaryClass) {
        return classRow
            ? getPrimarySubjectOptionsForClass(classRow)
            : [...PRIMARY_SCHOOL_SUBJECT_OPTIONS_UPPER];
    }
    return [...SECONDARY_SCHOOL_SUBJECT_OPTIONS];
}

/**
 * Stable internal code per school + class + row index + subject name (DB unique on subCode + schoolId).
 */
export function buildAutoSubCode(classId, rowIndex, subName) {
    const slug = String(subName)
        .replace(/[^a-zA-Z0-9]+/g, "")
        .slice(0, 20)
        .toUpperCase() || "SUBJECT";
    const cid = String(classId || "class").replace(/-/g, "").slice(-12);
    return `${slug}_${cid}_${rowIndex}`;
}
